import { useSyncExternalStore } from "preact/compat";

export class StoreSync {
    eventTarget: EventTarget;
    version: number = 0;

    constructor() {
        this.eventTarget = new EventTarget();
    }

    subscribe = (callback: () => void) => {
        this.eventTarget.addEventListener('update', callback);

        return () => {
            this.eventTarget.removeEventListener('update', callback);
        };
    }

    read = () => {
        return this.version;
    }

    notify = () => {
        this.version += 1;
        this.eventTarget.dispatchEvent(new Event('update'));
    }
}

export function useStoreSync(sync: StoreSync) {
    useSyncExternalStore(
        sync.subscribe,
        sync.read
    );
}